import { Link } from 'react-router-dom';
import { useStore } from '../lib/store';

export function Footer() {
  const { data } = useStore();

  // "All jewellery" is linked explicitly below, so exclude it here — the
  // migrated catalogue has it in the featured group too, which would otherwise
  // list it twice.
  const collections = (data?.categories ?? [])
    .filter(
      (c) =>
        c.menuGroup === 'featured' &&
        c.productCount > 0 &&
        c.slug !== 'all-jewellery',
    )
    .slice(0, 6);

  return (
    <footer className="mt-24 border-t border-border bg-surface">
      <div className="page-container grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <h2 className="font-heading text-xl">{data?.store?.name ?? "Gill's Handmade"}</h2>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-muted">
            {data?.store?.description ??
              'Artisan jewellery handmade with ceramic pieces and Czech glass beads.'}
          </p>

          {(data?.store?.socials.instagram || data?.store?.socials.facebook) && (
            <div className="mt-5 flex gap-4 text-xs uppercase tracking-widest">
              {data?.store?.socials.instagram && (
                <a
                  href={data.store.socials.instagram}
                  target="_blank"
                  // noreferrer alongside noopener: don't leak the shop's URL as
                  // a referrer to third-party sites.
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Instagram
                </a>
              )}
              {data?.store?.socials.facebook && (
                <a
                  href={data.store.socials.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:underline"
                >
                  Facebook
                </a>
              )}
            </div>
          )}
        </div>

        <nav aria-label="Shop">
          <h3 className="mb-4 text-xs uppercase tracking-widest">Shop</h3>
          <ul className="space-y-2 text-sm text-muted">
            <li>
              <Link to="/collections/all-jewellery" className="hover:text-ink">
                All jewellery
              </Link>
            </li>
            {collections.map((c) => (
              <li key={c.id}>
                <Link to={`/collections/${c.slug}`} className="hover:text-ink">
                  {c.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Information">
          <h3 className="mb-4 text-xs uppercase tracking-widest">Information</h3>
          <ul className="space-y-2 text-sm text-muted">
            {(data?.nav?.footer ?? []).map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="hover:text-ink">
                  {link.label}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/account" className="hover:text-ink">
                Find your order
              </Link>
            </li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-border">
        <div className="page-container flex flex-col items-center justify-between gap-2 py-5 text-xs text-muted md:flex-row">
          <p>
            © {new Date().getFullYear()} {data?.store?.name ?? "Gill's Handmade"}. Every
            piece made by hand.
          </p>
          <p>Free UK delivery · Royal Mail Tracked 24</p>
        </div>
      </div>
    </footer>
  );
}
